import { motion } from 'framer-motion';

const SectionDivider = ({ variant = 'line' }) => {
  if (variant === 'flower') {
    return (
      <div className="py-4 flex items-center justify-center bg-gradient-to-b from-transparent via-[#F5F0EB]/50 to-transparent">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex items-center gap-4"
        >
          <div className="w-12 md:w-20 h-[1px] bg-gradient-to-r from-transparent to-[#D7CCC8]" />
          <svg viewBox="0 0 40 40" className="w-8 h-8 md:w-10 md:h-10" fill="none">
            {/* Simple elegant flower */}
            <g opacity="0.5">
              <ellipse cx="20" cy="12" rx="4" ry="9" fill="#CCA598" />
              <ellipse cx="20" cy="12" rx="4" ry="9" fill="#CCA598" transform="rotate(72 20 20)" />
              <ellipse cx="20" cy="12" rx="4" ry="9" fill="#CCA598" transform="rotate(144 20 20)" />
              <ellipse cx="20" cy="12" rx="4" ry="9" fill="#CCA598" transform="rotate(216 20 20)" />
              <ellipse cx="20" cy="12" rx="4" ry="9" fill="#CCA598" transform="rotate(288 20 20)" />
              <circle cx="20" cy="20" r="4" fill="#5D4037" opacity="0.6" />
            </g>
          </svg>
          <div className="w-12 md:w-20 h-[1px] bg-gradient-to-l from-transparent to-[#D7CCC8]" />
        </motion.div>
      </div>
    );
  }

  if (variant === 'dots') {
    return (
      <div className="py-4 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex items-center gap-3"
        >
          <div className="w-10 md:w-16 h-[1px] bg-gradient-to-r from-transparent to-[#D7CCC8]" />
          <div className="flex gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-[#CCA598] opacity-40" />
            <div className="w-2 h-2 rounded-full bg-[#8D6E63] opacity-50" />
            <div className="w-1.5 h-1.5 rounded-full bg-[#CCA598] opacity-40" />
          </div>
          <div className="w-10 md:w-16 h-[1px] bg-gradient-to-l from-transparent to-[#D7CCC8]" />
        </motion.div>
      </div>
    );
  }

  // Default: line variant
  return (
    <div className="py-3 flex items-center justify-center">
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="w-24 md:w-40 h-[1px] bg-gradient-to-r from-transparent via-[#CCA598]/40 to-transparent"
      />
    </div>
  );
};

export default SectionDivider;
